import React, { useState, useEffect } from "react";
import { useBOMStore } from "src/hooks/bom";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import System from "../../../helper/system";
import { isArray } from "underscore";
import Bom from "@system/config/bom";
import { useCartStore } from "src/hooks/cart";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import alertic from "src/assets/images/yellow-alert.png";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import Constants from "src/helper/Constants";

window.openBOM = () => {
  localStorage.setItem(System.storageName.ANALYTICS_EVENT,Constants.analyticsEvent.BOM_OPENED)
}
const AddToBOMPopup = (props) => {
  const { SetStatus } = props;
  const [__check] = useAxiosIndicatorCheck();
  const [bomName, setBomName] = useState("");
  const [bomNameStatus, setBomNameStatus] = useState(true);
  const [bomListStatus, setBomListStatus] = useState(true);
  const [optionsSearchInput, setOptionsSearchInput] = useState("");
  const [listOfBOM, setListOfBOM] = useState({});
  const [bomNameError, setBomNameError] = useState(false);
  const [selectedBom, setSelectedBom] = useState([]);
  const [bomListError, setBomListError] = useState(false);
  const [{}, { system_alert_indicator }, {}] = useDOMAttachToSystemStore();
  const [
    { bom_list, bom_project_list },
    { fetch_bom_list, get_bom_detail_by_bom_id },
    { create_bom, add_part_to_bom, create_params_for_add_part_to_bom },
  ] = useBOMStore();
  const [{ CART_BEFORE_TO_SEND_SERVER }, {}, {}] = useCartStore();
  const { single_product, fromCart, addFrom, cartProduct } = props.data;
  const addToBomLoader = __check('BOM_ADD_TO_BOM_API_CALL').status;
  const createBomLoader = __check('BOM_CREATE_API_CALL').status;
  const FromCart = fromCart === "yes";
  const [{}, { get_inventory_by_id, get_pricing_by_id }, {}] =
    useProductInventoryPriceStore();

  const ERPPartNumber =
    !FromCart && single_product?.ERPPartNumber
      ? single_product.ERPPartNumber
      : "";
  const ERPMFRPartNumber = FromCart ? "" : single_product?.ERPMFRPartNumber;
  const ManufacturerPartNumber = FromCart
    ? ""
    : single_product?.ManufacturerPartNumber;
  const ItemNumber = FromCart ? "" : single_product?.ItemNumber;
  const Quantity = FromCart ? 0 : single_product?.QtyMin;
  const LifeCycleRisk =
    !FromCart && single_product?.LifeCycleRisk
      ? single_product.LifeCycleRisk
      : "";
  let selectedBOMDetails = [];

  useEffect(() => {
    if (props.data) {
      fetch_bom_list({ source: addFrom });
      setEnableDisable("bom_list", false);
      setBomNameStatus(true);
      setBomListStatus(true);
      setSelectedBom([]);
      SetStatus(true);
    }
  }, [props.data]);

  const onHide = (action = true) => {
    document.body.style.overflow = "";
    SetStatus(false);
  };

  const onBomNameChange = (name) => {
    setBomName(name);
    if (name !== "") {
      setBomListStatus(false);
      setEnableDisable("bom_list", true);
    } else {
      setBomListStatus(true);
      setEnableDisable("bom_list", false);
    }
  };

  useEffect(() => {
    setListOfBOM(optionsAvailable());
  }, [bom_list]);

  useEffect(() => {
    filterBomList(optionsSearchInput);
  }, [optionsSearchInput]);

  const optionsAvailable = () => {
    let LinkedWithSystem = {};
    if (Object.entries(bom_list).length > 0) {
      Object.entries(bom_list).map((v, i) => {
        LinkedWithSystem[v[1].bomId] = {
          bomId: v[1].bomId,
          bomName: v[1].bomName,
          isView: true,
        };
      });
    }
    return LinkedWithSystem;
  };

  const filterBomList = (param) => {
    let here = optionsAvailable();
    Object.entries(optionsAvailable()).filter((v, i) => {
      if (param && !v[1].bomName.toLowerCase().includes(param.toLowerCase())) {
        here[v[1].bomId].isView = false;
      }
    });
    setListOfBOM(here);
  };

  const setEnableDisable = (elementID, status) => {
    let _container = document.getElementById(elementID);
    if (_container !== null) {
      let _chks = _container.getElementsByTagName("INPUT");
      let _numChks = _chks.length - 1;

      for (let i = 0; i <= _numChks; i++) {
        let _type = _chks[i].getAttribute("type");
        if (_type == "checkbox" && status === false) _chks[i].checked = false;

        if (_type == "checkbox" && status === true) _chks[i].checked = false;

        _chks[i].disabled = status;
      }

      if (status === true) {
        setOptionsSearchInput("");
      }
    }
  };

  const setCheckAll = (check) => {
    let _container = document.getElementById("bom_list");
    if (_container !== null) {
      let _chks = _container.getElementsByTagName("INPUT");
      let _numChks = _chks.length - 1;

      for (let i = 0; i <= _numChks; i++) {
        _chks[i].checked = check;
      }
      setBomNameStatus(!check);
      if (check) {
        if (Object.keys(bom_list).length > 0) {
          let newBomList = [];
          Object.keys(bom_list).map((v, i) => {
            newBomList.push(bom_list[v].bomId);
          });
          setSelectedBom(newBomList);
        }
      } else {
        setSelectedBom([]);
      }
    }
  };

  const onListHandler = (bomId, value) => {
    let newBomList = [...selectedBom];
    if (value) {
      newBomList.push(bomId);
      setSelectedBom(newBomList);
    } else {
      let index = newBomList.indexOf(bomId);
      if (index !== -1) {
        newBomList.splice(index, 1);
      }
      setSelectedBom(newBomList);
    }
    if (newBomList.length > 0) {
      setBomNameStatus(false);
    } else {
      setBomNameStatus(true);
    }
  };

  const onCreateBom = async () => {
    if (bomName === "" || bomName.trim().length === 0) {
      setBomNameError(true);
    } else {
      let params = {};
      params.bomName = bomName;
      params.partNumber = ERPMFRPartNumber;
      params.ERPPartNumber = ERPPartNumber;
      params.ERPMFRPartNumber = ERPMFRPartNumber;
      params.quantity = Quantity;
      params.fromCart = FromCart;
      params.ManufacturerPartNumber = ManufacturerPartNumber;
      params.ItemNumber = ItemNumber;
      params.LifeCycleRisk = LifeCycleRisk;
      (params.customerPartNumber =
        CART_BEFORE_TO_SEND_SERVER[ItemNumber]?.CPN || ""),
        (params.source = addFrom);

      await create_bom(params).then(async (res) => {
        if (res) {
          onHide();
          setBomName("");
          let resL = await get_bom_detail_by_bom_id({ bomId: res.data });
          FromCart
            ? system_alert_indicator({
                name: "createBom",
                message:
                  "Cart has been added to " +
                  `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(res.data, {
                    addFrom: addFrom,
                  })}">${resL.payload.bomName}</a>`,
                type: "success",
                isDisplay: true,
              })
            : system_alert_indicator({
                name: "createBom",
                message:
                  params.ERPMFRPartNumber +
                  " has been added to " +
                  `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(res.data, {
                    addFrom: addFrom,
                  })}">${resL.payload.bomName}</a>`,
                type: "success",
                isDisplay: true,
              });
          System.setEvars(
            "",
            "",
            addFrom,
            resL?.payload?.bomName,
            resL?.payload?.bomId
          );
          if (window.adobeDataLayer) {
            selectedBOMDetails = {
              bomID: resL?.payload?.bomId,
              bomName: resL?.payload?.bomName,
            };
            let eventName = "createBOM";
            addToBOMEvent(eventName);
          }
        }
      });
    }
  };

  const onAddPartToBom = async (e) => {
    e.preventDefault();
    if (isArray(selectedBom) && selectedBom.length < 1) {
      setBomListError(true);
    } else {
      setBomListError(false);
      let links = "";
      let bomNameWithComa = "";
      let bomIdWithComa = "";
      selectedBom.map((v, i) => {
        bomIdWithComa +=
          bom_list[v].bomId +
          (selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null
            ? ", "
            : "");
        bomNameWithComa +=
          bom_list[v].bomName +
          (selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null
            ? ", "
            : "");
        links += `<a onClick="openBOM()" href="${Bom.getBomDetailByIdRouteURL(v, {
          addFrom: addFrom,
        })}">${bom_list[v].bomName}</a>${
          selectedBom[i + 1] !== undefined && selectedBom[i + 1] !== null
            ? ", "
            : ""
        }`;
        selectedBOMDetails = { bomID: bomIdWithComa, bomName: bomNameWithComa, source: bom_list[v]?.source };
      });

      let params = create_params_for_add_part_to_bom(
        { ...single_product, bomIds: selectedBom },
        FromCart
      );

      await add_part_to_bom(params).then(async (res) => {
        if (res) {
          onHide();
          setSelectedBom([]);
          FromCart
            ? system_alert_indicator({
                name: "addPartToBom",
                message: "Cart has been added to <b>" + links + "</b>",
                type: "success",
              })
            : system_alert_indicator({
                name: "addPartToBom",
                message:
                  params.ERPMFRPartNumber + " has been added to " + links,
                type: "success",
                isDisplay: true,
              });

          System.setEvars("", "", addFrom, bomNameWithComa, bomIdWithComa);
          if (window.adobeDataLayer) {
            addToBOMEvent("addToBOM");
          }
        }
      });
    }
  };

  //By Ramya Kannan [Add to BOM - Adobe script ]

  function addToBOMEvent(evntName) {
    localStorage.setItem("adobeEventType", evntName);
    let prodDetails = single_product ? [single_product] : [...cartProduct];
    let bomDetails = { ...selectedBOMDetails };
    bomDetails.projectId = bomDetails.bomID || bomDetails.projectId;
    bomDetails.newBOM = evntName.toLowerCase() == 'createbom' ? 'Yes' : 'No'
    bomDetails.source = evntName.toLowerCase() == 'createbom' ? addFrom : bomDetails?.source; 
    if (bom_project_list) {
      bomDetails.projectName =
        bom_project_list[bomDetails.projectId]?.projectName;
    }
    if (prodDetails) {
      prodDetails = prodDetails.map((data, int) => {
        let copyObj = { ...data };
        copyObj.qas =
          get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)
            ?.inventoryQty || 0;
            let priceVal = getPricing(copyObj);
            copyObj.priceSource = priceVal?.priceSource;
            copyObj.unitPrice = copyObj.unitPrice || priceVal?.marketPrice;
            copyObj.subtotal = copyObj.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
            copyObj.quantity =  copyObj.Quantity || priceVal?.quantity;
            return copyObj;
      });
    }

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({
        prodDetails,
        bomDetails,
      });
    }
  }

  //added by Ramya [Adobe script]

  const getPricing = (ele) => {
    let priceValues = get_pricing_by_id({
      uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber,
    });
    return priceValues && priceValues[0];
  };

  return (
    <>
      <div className="avnet-modal modal-600">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => {
              onHide();
            }}
          >
            ×
          </button>

          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading">{"Add to BOM"}</h3>
          </div>
          {/* Modal body */}

          <div className="modal-body">
            <div className="clearfix" />
            <div className="bs5 row gx-2">
              <div className="col-12">
                <div className="">
                  <label htmlFor="name" className="form-label">
                    Add To New BOM
                  </label>
                  {bomNameError && (
                    <div className="alert alert-danger fade in font-16 mb-2">
                      <span>A name is required to submit a BOM.</span>
                      <img className="ms-auto" src={alertic} alt="Alert icon" />
                    </div>
                  )}
                  {bomListError && (
                    <div className="alert alert-danger fade in font-16 mb-2">
                      <span>
                        Please select at least one BOM from drop-down or Create
                        a BOM
                      </span>
                      <img className="ms-auto" src={alertic} alt="Alert icon" />
                    </div>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="mb-3">
                  <input
                    type="text"
                    className={
                      bomNameError
                        ? "form-control form-control-sm error"
                        : "form-control form-control-sm"
                    }
                    id="bom_name"
                    placeholder="BOM NAME"
                    name="bom_name"
                    value={bomName}
                    onChange={(e) => onBomNameChange(e.target.value)}
                    disabled={!bomNameStatus || addToBomLoader || createBomLoader}
                  />
                </div>
              </div>
              <div className="col-auto align-self-end">
                <div className="mb-3">
                  <button
                    type="submit"
                    className="bs5 btn btn-primary btn-sm w145"
                    disabled={!bomNameStatus || addToBomLoader || createBomLoader}
                    onClick={onCreateBom}
                  >
                    {createBomLoader ? <i className="fa fa-spinner fa-spin" /> : "CREATE BOM"}
                  </button>
                </div>
              </div>
            </div>
            {__check(["BOM_API_CALL"]).render}
            {!__check(["BOM_API_CALL"]).status && (
              <div className="light-card m-b-10" id="bom_list">
                <div className="light-card-header dark-card-title">
                  <div className="light-card-title">
                    {listOfBOM !== undefined &&
                      Object.keys(listOfBOM).length > 0 && (
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input font-18 "
                            id="check_all"
                            name="checkAll"
                            checked={
                              Object.keys(listOfBOM).length ===
                              selectedBom.length
                            }
                            onChange={(e) => {
                              setCheckAll(e.target.checked);
                            }}
                          />
                          <label
                            className="form-check-label ps-0 text-black"
                            htmlFor="column"
                          >
                            Your BOM’s
                          </label>
                        </div>
                      )}
                  </div>
                  <div className="light-card-search ms-auto">
                    <div className="form-group has-search mb-0 font-normal">
                      <span className="fa fa-search text-black-stone form-control-feedback" />
                      <input
                        type="text"
                        className="form-control mb-0"
                        placeholder="Search BOM’s"
                        name="search"
                        value={optionsSearchInput}
                        onChange={(e) => {
                          setOptionsSearchInput(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="light-card-body p-0">
                  <div className="filter-checkbox-list">
                    {listOfBOM &&
                      Object.keys(listOfBOM).length > 0 &&
                      Object.keys(listOfBOM).map((v, i) => (
                        <div
                          className="form-check"
                          key={v}
                          style={{
                            display:
                              listOfBOM[v].isView === true ? "flex" : "none",
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input font-18"
                            id={i + "BOM_Data"}
                            name={i + "BOM_Data"}
                            onChange={(e) => {
                              onListHandler(
                                listOfBOM[v].bomId,
                                e.target.checked
                              );
                            }}
                          />
                          <label
                            className="form-check-label text-blue2 font-bold ellipses"
                            htmlFor={i + "BOM_Data"}
                            title={listOfBOM[v].bomName}
                          >
                            {listOfBOM[v].bomName}
                          </label>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Modal footer */}
          {!__check(["BOM_API_CALL"]).status && (
            <div className="modal-footer text-center">
              <div className="modal-footer-actions">
                <button
                  type="button"
                  className="bs5 btn btn-secondary btn-sm w145"
                  data-toggle="modal"
                  disabled={!bomListStatus || addToBomLoader || createBomLoader}
                  data-target="#BomModal"
                  onClick={() => {
                    onHide();
                  }}
                >
                  CANCEL
                </button>
                {
                  <button
                    type="button"
                    className="bs5 btn btn-primary btn-sm w145"
                    data-toggle="modal"
                    data-target="#BomModal"
                    disabled={!bomListStatus || addToBomLoader || createBomLoader}
                    onClick={onAddPartToBom}
                  >
                    {addToBomLoader ? <i className="fa fa-spinner fa-spin" /> : "Done"}
                  </button>
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddToBOMPopup;
